import { render } from "./PanoptoVideoEmbed.vue?vue&type=template&id=a0f64b14&scoped=true"
import script from "./PanoptoVideoEmbed.vue?vue&type=script&lang=js"
export * from "./PanoptoVideoEmbed.vue?vue&type=script&lang=js"

import "./PanoptoVideoEmbed.vue?vue&type=style&index=0&id=a0f64b14&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f64b14"]])

export default __exports__